import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import getStoreLocatorResults from "@/api/requests/consumerApi/getStoreLocatorResults";
import { Store } from "@/custom-types/StoreLocator";
import { useSelector } from "@/redux/hooks";
import { getCoordinates } from "@/redux/selectors/location";
import { getUserHistoryItems } from "@/utils/userHistory";

const RecentlyViewedCarousel = dynamic(
  () => import("./RecentlyViewedCarousel"),
  { ssr: false },
);

const RecentlyViewedCarouselWithData: React.FC = () => {
  const coordinates = useSelector(getCoordinates);
  const [recentlyViewedStores, setRecentlyViewedStores] = useState<Store[]>([]);
  const getRecentlyViewed = async () => {
    const storedDispensaries = await getUserHistoryItems("dispensary", {}, 5);
    const recentlyViewedIds = storedDispensaries?.length
      ? storedDispensaries.map((entry) => entry.resourceId).filter((id) => id)
      : [];
    if (recentlyViewedIds.length) {
      const { data } = await getStoreLocatorResults({
        disableGeoFilter: true,
        ids: recentlyViewedIds,
        mapData: {
          center: {
            lat: coordinates?.lat,
            lon: coordinates?.lon,
          },
        },
      });

      const stores = [...data.organicStores, ...data.sponsoredStores];

      if (stores.length) {
        setRecentlyViewedStores(
          stores.sort(
            (a, b) =>
              recentlyViewedIds.indexOf(a.id) - recentlyViewedIds.indexOf(b.id),
          ),
        );
      }
    }
  };

  useEffect(() => {
    getRecentlyViewed();
  }, [coordinates]);

  return recentlyViewedStores.length ? (
    <RecentlyViewedCarousel stores={recentlyViewedStores} />
  ) : null;
};

export default RecentlyViewedCarouselWithData;
